<template>
	<div class="flex-fill card mb-3">
  	  	<div class="card-header">
  	  		<span v-if="status.badge" class="badge float-right" :class="'badge-' + status.bootstrapColor">{{ status.badge }}</span>
  	  		<h5 class="card-title mb-0">{{ status.title }}</h5>
  		</div>
  		<div class="my-2 card-body">
  			<div class="d-flex align-items-center mb-4 row">
  				<div class="col-7">
  					<h3 class="d-flex align-items-center mb-0 font-weight-light">{{ status.number }}</h3>
				</div>
				<div class="text-right col-5">
					<span class="text-muted">{{ status.percentage }}%</span>
				</div>
			</div>
			<div class="progress-sm shadow-sm mb-1 progress">
				<div class="progress-bar" :class="'bg-' + status.bootstrapColor" :style="{width: status.percentage + '%'}" role="progressbar" :ariaValuenow="status.percentage" aria-valuemin="0" aria-valuemax="100"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Status',
	props: ['status']
}
</script>